import Queue from "nq-js";

class SignInUseCase {
  execute(user, options) {
    return new Queue.User().signIn(user, options);
  }
}

export default SignInUseCase;
